import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'
import { GroupDiscountsListWrapper } from './groups-discounts-list/GroupDiscountsList'

const groupdiscountsBreadcrumbs: Array<PageLink> = [
  {
    title: 'GroupDiscount Management',
    path: '/admin/pages/groupdiscounts',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/groupdiscounts/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const GroupDiscountsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='groupdiscounts'
          index
          element={
            <>
              <PageTitle breadcrumbs={groupdiscountsBreadcrumbs}>GroupDiscounts list</PageTitle>
              <GroupDiscountsListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/groupdiscounts/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/groupdiscounts' />} />
    </Routes>
  )
}

export default GroupDiscountsPage
